import {useEffect, useState} from "react";
import {useAuth} from "react-oidc-context";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const auth = useAuth();

  // Verificar configuración OIDC al cargar
  useEffect(() => {
    const checkConfig = () => {
      if (!process.env.REACT_APP_OIDC_AUTHORITY) {
        setError("Error: REACT_APP_OIDC_AUTHORITY no está configurado en el archivo .env");
        return;
      }
      if (!process.env.REACT_APP_OIDC_CLIENT_ID) {
        setError("Error: REACT_APP_OIDC_CLIENT_ID no está configurado en el archivo .env");
        return;
      }
      if (!process.env.REACT_APP_OIDC_REDIRECT_URI) {
        setError("Error: REACT_APP_OIDC_REDIRECT_URI no está configurado en el archivo .env");
        return;
      }
    };

    checkConfig();
  }, []);

  // Login con OpenID Connect
  const login = async (returnUrl = "/dashboard") => {
    try {
      setLoading(true);
      setError("");

      // Verificar que auth esté disponible
      if (!auth) {
        throw new Error("Contexto de autenticación no disponible");
      }

      // Verificar configuración antes de intentar login
      if (!process.env.REACT_APP_OIDC_AUTHORITY || !process.env.REACT_APP_OIDC_CLIENT_ID) {
        throw new Error("Configuración de OIDC incompleta. Revisa tu archivo .env");
      }

      console.log("Iniciando login OIDC con configuración:", {
        authority: process.env.REACT_APP_OIDC_AUTHORITY,
        client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI
      });

      console.log("Estado del contexto auth antes de signinRedirect:", {
        isAuthenticated: auth.isAuthenticated,
        isLoading: auth.isLoading,
        error: auth.error,
        user: auth.user
      });

      // Guardar la URL de retorno
      if (returnUrl) {
        sessionStorage.setItem("returnUrl", returnUrl);
        console.log("URL de retorno guardada:", returnUrl);
      }

      console.log("Llamando a auth.signinRedirect()...");
      // Iniciar el flujo de autenticación
      await auth.signinRedirect();

      console.log("signinRedirect completado exitosamente");

      return {success: true};
    } catch (error) {
      console.error("Error en login OIDC:", error);
      let errorMessage = "Error al iniciar sesión con OpenID Connect";

      if (error.message?.includes("configuración")) {
        errorMessage = error.message;
      } else if (error.message?.includes("authority")) {
        errorMessage = "Error en la URL del proveedor OIDC. Verifica REACT_APP_OIDC_AUTHORITY";
      }

      setError(errorMessage);
      return {success: false, error: errorMessage};
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError("");

  return {
    login, // Login con OpenID Connect
    loading,
    error,
    clearError
  };
};

export default useLogin;
